import {
    RolePermission, UsersPermissions, ProfessionalPermissions, ActivitiesPermissions, 
    ScheduledActivitiesPermissions, ContactsPermissions, InstallationsPermissions, HomePermissions,
    UserHistoryPermissions, UserInteractionsPermissions, UserDocumentsPermissions, ScheduledActivitiesOldPermissions, ExceptionsPermissions,
    ScalesPermissions, ObjectivesPermissions
} from "./permisions.model"

export default new RolePermission([
    new UsersPermissions({enabled: true, list: true, create: false, edit: false, show: true, del: false}),
    new ProfessionalPermissions({enabled: true, list: false, create: false, edit: false, show: false, del: false}),
    new ActivitiesPermissions({enabled: true, list: false, create: false, edit: false, show: false, del: false}),
    new ScheduledActivitiesPermissions({enabled: true, list: false, create: false, edit: false, show: false, del: false}),
    new ContactsPermissions({enabled: true, list: false, create: false, edit: false, show: false, del: false}),
    new UserHistoryPermissions({enabled: true, list: false, create: false, edit: true, show: false, del: false}),
    new UserInteractionsPermissions({enabled: true, list: true, create: false, edit: false, show: true, del: false}),
    new UserDocumentsPermissions({enabled: true, list: true, create: true, edit: true, show: false, del: true}),
    new ScheduledActivitiesOldPermissions({enabled: true, list: false, create: false, edit: false, show: false, del: false}),
    new InstallationsPermissions({ enabled: true, list: true, create: false, edit: false, show: true, del: false }),
    new HomePermissions({ enabled: true, list: true, create: false, edit: false, show: false, del: false }),
    new ExceptionsPermissions({ enabled: true, list: true, create: false, edit: false, show: false, del: false }),
    new ScalesPermissions({ enabled: true, list: true, create: true, edit: true, show: true, del: false }),
    new ObjectivesPermissions({ enabled: true, list: true, create: true, edit: true, show: true, del: false })


])